<template>
  <div class="referred">
    <v-card-text >
        <div class="choose-select">
          <v-select
            :items="post_items"
            label="انتخاب کنید."
            item-text="label"
            item-value="value"
            single-line
            v-model="selected_post"
          >
          </v-select>
        </div>
        <div class="req-list" >
          <div class="req-card" v-on:click="goToDetail(item)" v-for="item in request_items" :key="item.Id">
            <div>
              <div class="flex-no-wrap justify-space-between">
                <div>
                  <div
                    class="req-name"
                    v-text="item.RequestName"
                  ></div>

                  <span class="req-code">
                    به شماره درخواست
                    <span class="bold">
                    {{ item.RequestCode }}
                    </span>
                  </span>
                  <span class="req-date">
                    {{ item.ReqReceivDate }}
                    <v-icon>
                      mdi-calendar-range
                    </v-icon>
                  </span>

                  <div>
                    <div class="text-center">
                      <v-chip v-for="item_chip in item.PredefinedGlobal"
                              class="ma-1"
                              color="primary"
                      >
                        {{item_chip.Text}}:{{item_chip.Value}}
                      </v-chip>

                      <v-chip
                        v-for="item_chip in item.PredefinedChecked"
                        class="ma-1"
                        color="primary"
                      >
                        {{item_chip.Text}}:{{item_chip.Value}}

                      </v-chip>
                    </div>
                    <div class="address">
                      <v-icon>
                        mdi-map-marker
                      </v-icon>
                      {{get_request_address(item)}}
                    </div>
                    <div class="status">{{item.StatusName}}</div>
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">اطلاعاتی برای نمایش وجود ندارد</div>
      </infinite-loading>

    </v-card-text>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading';
  export default {
    props:[
      'passing_data'
    ],
    data() {
      return {
        list: [],
        errors: [],
        post_items:[],
        selected_post:0,
        selected_branch:0,
        request_items:[],
        last_request_items:[],
        show_loading: false,
        page: 0,
        rules: {
          required: value => !!value || 'الزامی',
          fullName: value => value.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || 'نام و نام خانوادگی فارسی نیست.'
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || 'فرمت موبایل صحیح نیست.'
          },
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
    },
    watch: {
      'selected_post':function (val) {
        console.log("vaaaal: ",val)
        this.page = 0;
        this.request_items=[]
        this.get_branch_by_post();
        this.show_loading = true;

      }
    },
    mounted() {
      this.get_posts();
    },

    methods: {
      goToDetail (item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if(item.IsFinalize == 1){
          this.$router.push({ name: 'ViewRequest', params: {rec_id:item.Id} })

        }else{
          this.$router.push({ name: 'ViewPreRequest', params: {rec_id:item.Id} })

        }
      },
      get_request_address (item) {
       var address = "";
       if(item.CityName != null){
         address +=  item.CityName+" ";
       }
       if(item.AreaName != null){
         address +=  item.AreaName+" ";
       }
       return address
      },
      get_branch_by_post() {
        var self = this;
          const send_data = {
            "PartyId": this.selected_post,
          };
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/GetBranchIdByPartyId', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                // console.log("response", response);
                // self.user_registered = true;
                // self.fullName = response.data.msg;
                // self.level = 2;
                self.selected_branch = response.data.branchId;
                self.get_pre_requests(null)
              }
              // this.$router.push({ path: "/post-login", params: {} });

            }).catch(e => {
            this.errors.push(e);

          })

      },
      get_posts() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        console.log();
        const send_data = {
          "UserId": user_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserParties', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.parties.forEach(function (number) {
                var obj = {label: number.PartyName, value: number.Id}
                self.post_items.push(obj);

              });
              if(self.post_items.length == 2){
                console.log("self.post_items[1]", self.post_items[1])
                self.selected_post = self.post_items[1].value
              }
            }
          }).catch(e => {
          this.errors.push(e);
        })

      },
      get_pre_requests($state) {
        // this.request_items = [];
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        const send_data = {
          "UserId": user_id,
          "Count": this.page,
          "BranchId": this.selected_branch,
        };

        console.log("pre request called");
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreRequestsByUserId', send_data, {})
          .then(response => {
            self.last_request_items =[]
            if (response.data.error == 0) {
              console.log("salam")
              response.data.requests.forEach(function (number) {
                self.request_items.push(number);

              });
              self.last_request_items = response.data.requests;
              self.list = response.data.requests;
              // console.log("salam")
              self.get_final_requests($state)

            }
          }).catch(e => {
          this.errors.push(e);
        })

      },
      get_final_requests($state) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        const send_data = {
          "ExpertId": user_id,
          BranchId: this.selected_branch,
          Count:this.page,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserDevicesByExpertId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.requests.forEach(function (number) {
                self.request_items.push(number);
                self.last_request_items.push(number);
              });
              if(self.first){
                self.first = false;
                // self.infiniteHandler()

              }
              if($state !=null){
                if(self.last_request_items.length>0){
                  console.log("loaded called")
                  $state.loaded();
                }else{
                  console.log("complete called")

                  $state.complete();
                }
              }
            }
          }).catch(e => {
          this.errors.push(e);
        })

      },
      infiniteHandler($state) {
        var self =this;
        console.log("first is "+this.first);
       if(this.first){
         // $state.loaded();
         setTimeout(() => {

           $state.loaded();
         }, 1000);
         return false;
       }

        console.log("hiii"+ self.last_request_items.length)
        setTimeout(() => {

          // if (self.last_request_items>0 ) {
            self.page += 1;
            self.get_pre_requests($state);
            // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
          }, 1000);


        },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
